import styled, { keyframes } from 'styled-components';
import { ReactComponent as BackImage } from '../assets/earth.svg';

export type RoadmapItemProps = {
  disabled?: boolean;
  backgroundColor?: string;
  backgroundElement: any;
  shadow?: string;
  left: string;
  top: string;
  pendingApproval?: boolean;
};
const RoadmapItem = styled.div<RoadmapItemProps>`
  background: url(${({ backgroundElement }) => backgroundElement});
  position: absolute;
  left: ${({ left }) => left};
  top: ${({ top }) => (top ? '-' + top : 0)};
  // top: 0;
  justify-content: center;
  max-width: 183px;
  max-height: 183px;
  padding: 0;
  margin: 0;
  min-height: 183px;
  width: 183px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: url(${({ backgroundElement }) => backgroundElement}),
    ${({ backgroundColor }) => backgroundColor};
  filter: drop-shadow(${({ shadow }) => shadow});
  box-shadow: inset -60px 0px 50px -50px rgb(43 28 28 / 55%);
  -webkit-box-shadow: inset -60px 0px 50px -50px rgb(43 28 28 / 55%);
  -moz-box-shadow: inset -60px 0px 50px -50px rgb(43 28 28 / 55%);
  border-radius: 50%;
  cursor: pointer;
  transition: 0.1s all;
  text-decoration: none;
  &:hover:not(:disabled) {
    filter: drop-shadow(0px 0px 20px #00ffa5);
    z-index: 999;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const ringPulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(217, 119, 6, 0.7), 0 0 0 4px rgba(217, 119, 6, 0.3); }
  50% { box-shadow: 0 0 0 8px rgba(217, 119, 6, 0), 0 0 0 14px rgba(217, 119, 6, 0); }
`;

export const PendingRing = styled.div`
  position: absolute;
  border-radius: 50%;
  border: 3px solid #d97706;
  animation: ${ringPulse} 2s ease-in-out infinite;
  pointer-events: none;
  z-index: 1000;
`;

export const PendingLabel = styled.div`
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #b45309, #d97706);
  color: white;
  font-size: 9px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(217,119,6,0.6);
  pointer-events: none;
`;

export default RoadmapItem;
